import { Box, TextField, Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import React from 'react';
import { useTranslation } from 'services/localization';

interface Props {
	value: string;
	error: string | undefined;
	onChange: (value: string) => void;
	autoFocus?: boolean;
}

export const DiscountCodeName = (props: Props) => {
	const { t } = useTranslation();
	const { value, error, onChange, autoFocus = false } = props;
	return (
		<ContainerBox padding="normal">
			<Box mb={3}>
				<Typography variant="h6">{t('discount.discountCode', 'Discount code')}</Typography>
			</Box>
			<TextField
				autoFocus={autoFocus}
				autoComplete="off"
				id="discount code"
				variant="standard"
				name={'discountCode'}
				value={value}
				onChange={(e) => onChange(e.target.value.trim())}
				margin="normal"
				type="text"
				error={Boolean(error)}
				helperText={
					error ||
					t(
						'discount.customersWillEnterCodeAtCheckout',
						'Customers will enter this code at checkout.',
					)
				}
			/>
		</ContainerBox>
	);
};
